module.exports = __webpack_public_path__ + "assets/6537122b3fe680dac7cc137143a2422d.mp3";